module.exports = __webpack_public_path__ + "static/media/grip.45df3e5d.svg";